import {Component, HostBinding, Input} from '@angular/core';
import {environment} from '../environments/environment';
import {LocalizationService} from './shared/services/localization.service';
import {AssetsService} from './shared/services/assets.service';
import {AccountService} from './shared/services/account.service';
import {CrawlerService} from './shared/services/crawler.service';
import {ImgEnum} from './shared/models/assets.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'smart-assistant';
    @HostBinding('class.smart-assistant') default = true;
    @Input() lang: string | undefined;
    
    constructor(private localizationService: LocalizationService,
                private assetService: AssetsService,
                private accountService: AccountService,
                private crawlerService: CrawlerService) {
        console.log(environment);
        this.localizationService.setLanguage(this.lang);
    }
    
    protected readonly ImgEnum = ImgEnum;
}
